import type { AlertBody } from "./alerts.ts";

export const sourceOf = (alert: AlertBody): string | undefined => ("fonte" in alert.values ? alert.values.fonte : undefined);
